module.exports = __webpack_public_path__ + "img/urban-icon.a487d35d.svg";